// Nunito Sans wurde bislang global in index.tsx geladen und damit auf JEDER
// Karte angefordert — auch dort, wo ein Marken-Template (eigene Schrift, z. B.
// Inter) rendert und kein einziges Element sie zeigt (Spec §2.4, gemessen
// 13,7 kB fuer 0 gerenderte Elemente). Ursache war NICHT ClassicTemplate
// selbst, sondern der `@font-face`-Import: solange er unbedingt registriert
// ist, greift die `.text`-Regel (Text.css) auch fuer transiente Inhalte wie
// den Ladespinner (pages/Loading.tsx), die auf JEDER Kartenart kurz
// aufscheinen, bevor ein Marken-Bundle geladen ist.
//
// Deshalb: `@font-face` fuer Nunito Sans wird jetzt NUR dort registriert, wo
// tatsaechlich Inhalt in dieser Schrift gerendert wird — Classic-Rueckfall
// (ClassicTemplate.tsx) und die Marketing-Startseite (pages/Landing.tsx).
// Ein Marken-Template ruft diese Funktion nie auf.
let requested = false;

/**
 * Die eigentlichen Nachlade-Aufrufe stehen bewusst als LITERALE `import()`
 * hier drin, statt einen Spezifizierer als Parameter durchzureichen: Vite/
 * Rollup erkennt nur woertliche `import('...')`-Aufrufe statisch und kann sie
 * dann als eigene CSS-Chunks code-splitten. Ein generischer
 * `importer(specifier: string)`-Wrapper (wie bei TemplateLoader, dort mit zur
 * Laufzeit vom Server kommender URL) waere hier der falsche Kunstgriff: der
 * Bundler saehe nur eine Variable und liesse die Dateien komplett aus dem
 * Build heraus — mutationsprobierbar, siehe loadNunitoSans.test.ts.
 */
function importNunitoSans(): void {
  void import('@fontsource/nunito-sans/300.css');
  void import('@fontsource/nunito-sans/700.css');
}

/**
 * Laedt Nunito Sans (300 + 700) bedingt nach. Idempotent ueber ein Modul-Flag
 * — React-StrictMode-Doppelrender und mehrere Mounts (mehrere Standorte,
 * erneutes Rendern) loesen keinen zweiten Nachlade-Vorgang aus.
 *
 * `loader` ist ausschliesslich fuer Tests injizierbar — Aufrufer im
 * Produktivcode uebergeben nichts und bekommen den echten dynamischen Import.
 */
export function loadNunitoSans(loader: () => void = importNunitoSans): void {
  if (requested) return;
  requested = true;
  loader();
}
